module.exports = __webpack_public_path__ + "static/img/history.f62ac27.svg";